module.exports = __webpack_public_path__ + "img/elections-2025-img-2.3dec1618.webp";